/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} St_Pricing_Feat1Inputs */

const en_st_pricing_feat1 = /** @type {(inputs: St_Pricing_Feat1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5 member seats, unlimited clients`)
};

const id_st_pricing_feat1 = /** @type {(inputs: St_Pricing_Feat1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5 seat anggota, klien tak terbatas`)
};

/**
* | output |
* | --- |
* | "5 member seats, unlimited clients" |
*
* @param {St_Pricing_Feat1Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const st_pricing_feat1 = /** @type {((inputs?: St_Pricing_Feat1Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<St_Pricing_Feat1Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_st_pricing_feat1(inputs)
	return en_st_pricing_feat1(inputs)
});